export default "__VITE_ASSET__c28e12cd__"